const module = { name: 'person/overview/app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as overviewWall } from 'swug-fdRequire-call:person/overview/wall';



import { default as caligariCarousel } from 'swug-fdRequire-call:shared/global/carousels/caligariCarousel';



import { default as deferImages } from 'swug-fdRequire-call:global/jcarousel.deferImages';

function run() {
    checkDependencies(module.name, debugLog);
    overviewWall.init();
    caligariCarousel.init('popFilmographyCarousel');
    deferImages.init();
}
run();
export default module.exports;